export const COOKIE_POLICY_ACCEPTED = 'policy-accepted';
export const COOKIE_POLICY_USER_ID = 'policy-user-id';
export const IS_COUNTER_EXPIRED = 'is-counter-expired';
export const ADVERTISING_SCRIPTS_ADDED = 'advertising-scripts-added';
export const STATISTIC_SCRIPTS_ADDED = 'statistic-scripts-added';
